import { matchPath } from 'react-router-dom';
import updateEntityVersion from '../../common/actions/updateEntityVersion';
import { initializeCommentsPanel, resetComments } from './commentsSlice';

import { fetchHypothesisSucceeded } from '../hypotheses/hypothesisSlice';
import { fetchAnalysisSucceeded } from '../analyses/analysisSlice';
import { getFreeformAnalysis } from '../analyses/editFreeformAnalysisSlice';

export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
export const ACTIONS_WITH_VERSION_CHANGE = [
  fetchHypothesisSucceeded.type,
  fetchAnalysisSucceeded.type,
  getFreeformAnalysis.fulfilled.type,
];

export const commentPaths = [
  {
    entityType: 'project',
    path: '/projects/:projectId',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: projectId,
        entityType: this.entityType,
        versionRequired: false,
      };
    },
  },
  {
    entityType: 'hypothesis',
    path: '/projects/:projectId/key-focus-areas/:hypothesisId/view',
    formatInitCommentsObject({ projectId, hypothesisId }) {
      return {
        projectId,
        entityId: hypothesisId,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'hypothesis',
    path: '/projects/:projectId/key-focus-areas/:hypothesisId/edit',
    formatInitCommentsObject({ projectId, hypothesisId }) {
      return {
        projectId,
        entityId: hypothesisId,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'insight',
    path: '/projects/:projectId/insights/:insightId/view',
    formatInitCommentsObject({ projectId, insightId }) {
      return {
        projectId,
        entityId: insightId,
        entityType: this.entityType,
        versionRequired: true,
        embedEditor: false,
      };
    },
  },
  {
    entityType: 'insight',
    path: '/projects/:projectId/insights/:insightId/edit',
    formatInitCommentsObject({ projectId, insightId }) {
      return {
        projectId,
        entityId: insightId,
        entityType: this.entityType,
        versionRequired: true,
        embedEditor: false,
        showCommentsPanel: false,
      };
    },
  },
  {
    entityType: 'analysis',
    path: '/projects/:projectId/analyses/:analysisId/view',
    formatInitCommentsObject({ projectId, analysisId }) {
      return {
        projectId,
        entityId: analysisId,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'analysis',
    path: '/projects/:projectId/analyses/:analysisId/edit',
    formatInitCommentsObject({ projectId, analysisId }) {
      return {
        projectId,
        entityId: analysisId,
        entityType: this.entityType,
        versionRequired: true,
        showCommentsPanel: false,
        embedEditor: false,
      };
    },
  },
  {
    entityType: 'debt-debt-like',
    path: '/projects/:projectId/analyses/debt-debt-like',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'debt-debt-like',
    path: '/projects/:projectId/analyses/debt-debt-like/edit',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
        showCommentsPanel: false,
        embedEditor: false,
      };
    },
  },
  {
    entityType: 'net-working-capital',
    path: '/projects/:projectId/analyses/net-working-capital',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'net-working-capital',
    path: '/projects/:projectId/analyses/net-working-capital/edit',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
        showCommentsPanel: false,
        embedEditor: false,
      };
    },
  },
  {
    entityType: 'analysis',
    path: '/projects/:projectId/analyses/:analysisId/view',
    formatInitCommentsObject({ projectId, analysisId }) {
      return {
        projectId,
        entityId: analysisId,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'analysis',
    path: '/projects/:projectId/analyses/:analysisId/edit',
    formatInitCommentsObject({ projectId, analysisId }) {
      return {
        projectId,
        entityId: analysisId,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'debt-debt-like',
    path: '/projects/:projectId/analyses/debt-debt-like',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'quality-of-earnings',
    path: '/projects/:projectId/analyses/quality-of-earnings/edit',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'net-working-capital',
    path: '/projects/:projectId/analyses/net-working-capital',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'net-working-capital',
    path: '/projects/:projectId/analyses/net-working-capital/edit',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'debt-debt-like',
    path: '/projects/:projectId/analyses/debt-debt-like/edit',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'quality-of-earnings',
    path: '/projects/:projectId/analyses/quality-of-earnings',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
  {
    entityType: 'quality-of-earnings',
    path: '/projects/:projectId/analyses/quality-of-earnings/edit',
    formatInitCommentsObject({ projectId }) {
      return {
        projectId,
        entityId: 1,
        entityType: this.entityType,
        versionRequired: true,
      };
    },
  },
];

const commentMiddleware = (store) => (next) => (action) => {
  if (next !== undefined) next(action);

  if (action.type === LOCATION_CHANGE) {
    const { pathname } = action.payload.location;

    const matchedPaths = commentPaths.filter(({ path }) =>
      matchPath(pathname, {
        path,
        exact: true,
      })
    );

    const matchedPath =
      matchedPaths.length !== 0
        ? matchedPaths[matchedPaths.length - 1]
        : undefined;

    const { pathname: pathnameFromState, showCommentsPanel } =
      store.getState().comments;

    const pathnameChanged = pathnameFromState !== pathname;

    if (pathnameChanged && matchedPath !== undefined) {
      const { params } = matchPath(pathname, { path: matchedPath.path });
      const initCommentsObject = matchedPath.formatInitCommentsObject(params);
      next(
        initializeCommentsPanel({
          ...initCommentsObject,
          pathname,
        })
      );
    } else if (pathnameChanged && showCommentsPanel) {
      next(resetComments());
    }
  }

  if (
    ACTIONS_WITH_VERSION_CHANGE.includes(action.type) &&
    action.payload?.versionNumber
  ) {
    next(updateEntityVersion(action.payload.versionNumber));
  }
};

export default commentMiddleware;
